import { Grid, Typography } from "@mui/material";

const styles = {
  badge: {
    my: 2,
    background: "#F8F4E9",
    p: 2,
    borderRadius: "20px",
  },
  chip: {
    py: 1,
    px: 2,
    mb: 1,
    fontWeight: 700,
    fontSize: "18px",
    color: "#151F16",
    borderRadius: "20px",
    border: `1px solid rgba(21, 31, 22, 0.2)`,
  },
  caption: {
    width: "80%",
    textAlign: "center",
    mt: 1,
    fontSize: "16px",
    opacity: "60%",
  },
  opportunityBox: {
    background: "white",
    borderRadius: "20px",
    p: 2,
    mb: 2,
  },
  title: {
    width: "100%",
    textAlign: "center",
    fontSize: "18px",
    fontWeight: 600,
  },
  subtitle: {
    fontSize: "16px",
    textAlign: "center",
    width: "80%",
    opacity: "60%",
  },
};

const OPPORTUNITIES = [
  {
    icon: "💭",
    title: "Check in more often",
    subtitle: "Stay front and center with brands you want to work with",
  },
  {
    icon: "💭",
    title: "Upsell add-ons and Bundles",
    subtitle:
      "Upsell extra content like Stories, Reels, or UGC content for higher pay",
  },
  {
    icon: "💭",
    title: "Reply faster",
    subtitle: "Respond quickly - fast replies help you lock in more deals",
  },
];

export default function Opportunities() {
  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Typography component="div" sx={styles.chip}>
        Opportunities
      </Typography>
      <Typography sx={styles.caption} paragraph>
        Based on your history, here are quick wins you can try next time:
      </Typography>
      {OPPORTUNITIES.map((opportunity, idx) => (
        <Grid
          item
          xs={12}
          justifyContent="center"
          container
          sx={styles.opportunityBox}
          key={idx}
        >
          <Typography sx={[styles.title, { fontSize: "32px" }]}>
            {opportunity.icon}
          </Typography>
          <Typography sx={styles.title} gutterBottom>
            {opportunity.title}
          </Typography>
          <Typography sx={styles.subtitle} paragraph>
            {opportunity.subtitle}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
